import { render, staticRenderFns, recyclableRender, components } from "./component.vue?vue&type=template&id=511be785&scoped=true&"
var renderjs
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=511be785&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511be785",
  null,
  false,
  components,
  renderjs
)

export default component.exports